import { ref, push, set, update } from "firebase/database";
import { db } from "../../../functions/api_firebase";


const ESPERA_MS = 800;
const TOPE_TANDA = 300;

const formatearCorreo = (correo) => {
  if (!correo) return "sin_correo";
  return correo.replace(/[@.]/g, "");
};

let pendientes = {};
let clavesEnTanda = new Set();
let temporizador = null;

const enviarTanda = () => {
  if (temporizador) {
    clearTimeout(temporizador);
    temporizador = null;
  }

  const tanda = pendientes;
  pendientes = {};
  clavesEnTanda = new Set();

  const rutas = Object.keys(tanda);
  if (!rutas.length) return;

  update(ref(db), tanda).catch((error) =>
    console.error("❌ Error al registrar log:", error.message)
  );
};

const encolar = (ruta, registro, clave) => {
  pendientes[ruta] = registro;
  clavesEnTanda.add(clave);

  if (Object.keys(pendientes).length >= TOPE_TANDA) {
    enviarTanda();
    return;
  }

  if (temporizador) clearTimeout(temporizador);
  temporizador = setTimeout(enviarTanda, ESPERA_MS);
};

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", enviarTanda);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") enviarTanda();
  });
}

export const crearLog = (url, accion) => {
  try {
    if (url && url.replace(/^\//, "").startsWith("logs/")) return;

    const permisos = localStorage.getItem("Permisos");
    if (permisos === "SUPER") return;

    const correo = localStorage.getItem("CorreoElectronico");
    const nit = localStorage.getItem("CodigoCliente");

    const ahora = new Date();
    const year = ahora.getFullYear();
    const month = String(ahora.getMonth() + 1).padStart(2, "0");
    const day = String(ahora.getDate()).padStart(2, "0");

    const correoFormateado = formatearCorreo(correo);
    const urlPrincipal = `logs/${nit}/${year}/${month}/${day}/${correoFormateado}`;

    const registro = {
      usuario: correo,
      url,
      accion,
      version: "1.0.0",
      dispositivo: "web",
      fecha: ahora.toISOString(),
      permisos,
    };

    if (accion !== "leer") {
      set(push(ref(db, urlPrincipal)), registro).catch((error) =>
        console.error("❌ Error al registrar log:", error.message)
      );
      return;
    }

    const clave = `${accion}|${url}`;
    if (clavesEnTanda.has(clave)) return;

    const idLog = push(ref(db, urlPrincipal)).key;
    encolar(`${urlPrincipal}/${idLog}`, registro, clave);
  } catch (error) {
    console.error("❌ Error al registrar log:", error.message);
  }
};
